import * as uuid from "uuid";
import {getTranslate} from "../../../../localization/localizeSlice";
import {getNumberOfArticles, getProductsTotalSum} from "../../../selectors";
import {CLOSE_QCO} from "../../../actionTypes";

export const ED = {
    port: false,
    url: 'wss://localhost.erply.com',
    available: false,
    scaleConfigured: false,
    displayConfigured: false,
    log: function(){
        let newArgs = Array.prototype.slice.call(arguments);
        newArgs.unshift('ED: ');
        console.log.apply(this, newArgs);
    },
    init: (config) => {
        ED.port = config.Port;
        ED.openWebSocket().then(() => {
            if(config.ScalePortName !== "" && config.ScalePortName !== "put the scale port here" && config.ScaleDeviceType !== ""){
                ED.scaleConfigured = true;
            }
            if(config.DisplayPortName !== "" && config.DisplayPortName !== "put the scale port here" && config.DisplayDeviceType !== ""){
                ED.displayConfigured = true;
                ED.customerDisplay.showIdle();
            }
        });
    },
    openWebSocket: function () {
        return new Promise(function (resolve, reject) {
            ED.websocket = new WebSocket(ED.url + ':' + ED.port);
            ED.websocket.onopen = function () {
                ED.log("websocket onopen");
                ED.available = true;
                resolve();
            };
            ED.websocket.onmessage = function (response) {
                ED.log("websocket: Message is received:", response.data);
                const data = JSON.parse(response.data);
                if(data.function === 'ScaleWeight'){
                    ED.onScaleWeight(data);
                }
            };
            ED.websocket.onclose = function () {
                ED.log("websocket onclose");
                delete ED.websocket;
                ED.available = false;
            }
        });
    },
    onStateChange: (store, state, action) => {
        if(action.type === CLOSE_QCO){
            ED.log("CLOSE_QCO");
            ED.websocket.close();
        }
    },
    onScaleWeight: () => {},
    scaleWeight: (resolve) => {
        ED.log('scaleWeight');
        if(typeof ED.websocket === "undefined"){
            resolve({
                statusMessage: 'Scale integration is not running'
            });
            return;
        }
        const id = uuid.v4();
        ED.onScaleWeight = resolve;
        ED.websocket.send(JSON.stringify({
            function: "ScaleWeight",
            id
        }));
    },
    customerDisplay: {
        showIdle: () => {
            ED.websocket.send(JSON.stringify({
                function: "ShowIdleScreen",
                id: uuid.v4()
            }));
        },
        addProduct: (product, state, total = parseFloat(getProductsTotalSum(state.rootReducer.productsInBasket))) => {
            ED.websocket.send(JSON.stringify({
                function: "DisplayPrint",
                id: uuid.v4(),
                data: {
                    total,
                    totalQuantity: getNumberOfArticles(state.rootReducer.productsInBasket),
                    rows: [
                        {
                            name: product.name,
                            finalPriceWithVAT: product.rowTotal,
                            rowNumber: product.lineNumber,
                            amount: product.amount
                        }
                    ]
                }
            }));
        },
        removeProduct: (product, state, total = parseFloat(getProductsTotalSum(state.rootReducer.productsInBasket))) => {
            const translate = getTranslate(state);
            ED.websocket.send(JSON.stringify({
                function: "DisplayPrint",
                id: uuid.v4(),
                data: {
                    total,
                    totalQuantity: getNumberOfArticles(state.rootReducer.productsInBasket),
                    rows: [
                        {
                            name: translate("correction").toUpperCase(),
                            finalPriceWithVAT: product.rowTotal * -1,
                            rowNumber: product.lineNumber,
                            amount: product.amount * -1
                        }
                    ]
                }
            }));
        },
        payment: (payment, state) => {
            const translate = getTranslate(state);
            let data = {};
            if(payment.type === "CASH"){
                data = {
                    lines: [
                        {
                            left: translate("Cash paid").toUpperCase() + ":",
                            right: parseFloat(payment.cashPaid).toFixed(2)
                        },
                        {
                            left: translate("Cash change").toUpperCase() + ":",
                            right: parseFloat(payment.cashChange).toFixed(2)
                        }
                    ]
                };
            }else{
                data = {
                    lines: [
                        {
                            left: translate("Total").toUpperCase() + ":",
                            right: state.payment.totalSum
                        },
                        {
                            left: translate("Left to pay").toUpperCase() + ":",
                            right: (parseFloat(state.payment.totalSum) - parseFloat(state.payment.totalPaid)).toFixed(2)
                        }
                    ]
                }
            }
            ED.websocket.send(JSON.stringify({
                function: "DisplayPrint",
                id: uuid.v4(),
                data
            }));
        }

    },
    posEvents: {
        lastProduct: false,
        lastProductAction: 'ADD',
        addProduct: (product, state) => {
            if(ED.displayConfigured){
                ED.posEvents.lastProduct = product;
                ED.posEvents.lastProductAction = 'ADD';
                ED.customerDisplay.addProduct(product, state);
            }
        },
        removeProduct: (product, state) => {
            if(ED.displayConfigured){
                ED.posEvents.lastProduct = product;
                ED.posEvents.lastProductAction = 'REMOVE';
                ED.customerDisplay.removeProduct(product, state);
            }
        },
        updateProducts: (event, state) => {
            if(ED.displayConfigured){
                if(ED.posEvents.lastProductAction === 'ADD'){
                    let product = {};
                    let productRow = event.rows[event.rows.length - 1];
                    product.name = ED.posEvents.lastProduct.name;
                    product.rowTotal = productRow.finalPriceWithVAT;
                    product.lineNumber = ED.posEvents.lastProduct.lineNumber;
                    product.amount = parseFloat(productRow.amount);
                    ED.customerDisplay.addProduct(product, state, event.total);
                }else{
                    ED.customerDisplay.removeProduct(ED.posEvents.lastProduct, state, event.total);
                }
            }
        },
        initTransaction: () => {
            ED.customerDisplay.showIdle();
        },
        addPayment: (payment, state) => {
            ED.customerDisplay.payment(payment, state);
        }
    }
};

window.ED = ED;
